/*
 * @Author: 刘小博
 * @Date: 2023-02-17 15:19:02
 * @LastEditTime: 2023-02-17 15:37:36
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\basic-content-manage\index.js
 * 基础内容管理
 */
import contentManageRouter from './modules/contentManageRouter'
const basicContentManageRouter = [].concat(contentManageRouter)

export default basicContentManageRouter
